import { PropertyReference } from "./property-reference";
import { Thing } from "./thing";
import { User } from "./user";

export class Ticket {
    id: string;
    code: string;
    organizationId: string;
    partnerId: string;
    responsibileName: string;
    creationOrganizationId: string;
    creationCustomerId: string;
    creationPartnerId: string;
    creationUserId: string;
    creationUser: User;
    thingId: string;
    thing: Thing;
    title: string;
    typeId: string;
    type: TicketType;
    status: TicketStatus;
    creationTimestamp: number;
    assigneeUserId: string;
    assigneeUser: User;
    items: TicketItem[];
    properties: { [name: string]: string | number };
    eventId: string;
}

export class TicketType {
    id: string;
    name: string;
    label: string;
    propertyReferences: PropertyReference[];
    eventSelectionEnabled: boolean;
}

export enum TicketStatus {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    ON_HOLD = 'ON_HOLD',
    RESOLVED = 'RESOLVED',
    REJECTED = 'REJECTED'
}

export class TicketItem {
    timestamp: number;
    userId: string;
    user: User;
    type: TicketItemType;
    statusChange: TicketItemStatusChange;
    note: TicketItemNote;
    attachment: TicketItemAttachment;
}

export enum TicketItemType {
    STATUS_CHANGE = 'STATUS_CHANGE',
    NOTE = 'NOTE',
    ATTACHMENT = 'ATTACHMENT'
}

export class TicketItemStatusChange {
    from: TicketStatus;
    to: TicketStatus;
}

export class TicketItemNote {
    content: string;
}

export class TicketItemAttachment {
    filename: string;
    type: TicketItemAttachmentType;
    s3Key: string;
    url: string;
}

export enum TicketItemAttachmentType {
    IMAGE = 'IMAGE',
    OTHER = 'OTHER'
}